<template>
  <div>
  <form novalidate>
    <div class="row  wizard-tab-container">
      <loader v-if="!isLoaded"></loader>

      <div class="col-lg-8 col-12">

        <h1 class="page-title" v-if="protocol">{{protocol.title}}: {{currentStage.description}}</h1>

        <div class="row mt-2 mb-3" v-if="isPreviousDateSession && protocolsData && protocolsData.endDate" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
          <div class="col-12">
            <div class="alert-danger text-center" v-if="showDatePrevious">
              {{'protocol.enter_another_session_date' | trans}} <strong>{{minDate | toLocaleDateTime}}</strong>
            </div>
            <div class="alert-secondary text-center" v-if="!showDatePrevious">
              {{'protocol.end_session_date' | trans}}: <strong>{{minDate | toLocaleDateTime}}</strong>
            </div>
          </div>
        </div>

        <div class="alert alert-warning" v-if="maxTotalAtemptsCountError">
          {{'protocol.max_count_for_session' | trans}}
        </div>


        <div class="wrapper-loader position-relative">
          <loader v-if="(!(previousDate && previousTime && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious" class="table-loader position-absolute without-img"
                  messages=""></loader>

            <div class="prev-list" @click.prevent="toggleViewPrev()" :class="{'is-open': isOpenPrev, 'is-list': prevTasks.length > 1}">

              <div v-for="(task,index) in prevTasks" :key="task.globalUuid" class="list-item">

                <span>{{task.description}}</span>
                <div>
                  <button type="button"
                          class="btn btn-link"
                          v-if="!(task.selected || task.disabled)"
                          @click.stop="selectAsCurrent(task.globalUuid)">
                    {{'protocol.make_criteria_current' | trans}}
                  </button>
                </div>

              </div>

            </div>


          <div v-if="selectedTasks && !isMobile" >
            <table class="table table-sm table-fixed border-primary mt-2 mb-2">

              <tbody class="gray-700">
              <tr class="selected" >
                <td class="item mw120">{{selectedTasks.description}}</td>
                <td class="item show-on-active nowrap" v-if="selectedTasks.selected">{{selectedTasks.attempt}}</td>
                <td class="table-count item  show-on-active" v-if="isBCBA || isCurator">
                  <mdc-textfield id="attepmtsCount"
                                 ref="attepmtsCount"
                                 v-on:keydown="changeNumber"
                                 type="number"
                                 min="1"
                                 max="1000"
                                 name="attepmtsCount"
                                 v-model="selectedTasks.attepmtsCount"
                                 v-validate="'min_value:1|numeric'"/>
                </td>
                <td class="results-cell item">
                  <div class="mt-2">
                          <span v-for="(answer, index) in selectedTasks.lastAnswers" class="item-box" :class="{'hidden': selectedTasks.lastAnswers.length > 5 && index < (selectedTasks.lastAnswers.length -5)}">
                            {{answer}}
                          </span><span v-for="n in emptyLength(selectedTasks.lastAnswers.length)" class="item-box-light"></span>
                  </div>

                  <div
                      class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                      v-for="(label, key) in selectedTasks.type.answers">
                    <div
                        class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                      <input :id="'id' + selectedTasks.globalUuid + label.id +key"
                             type="radio" class="mdc-radio__native-control"
                             v-model="selectedTasks.answer"
                             :name="'radios'+ selectedTasks.globalUuid + label.id +key"
                             :key="label.title + selectedTasks.globalUuid + label.id +key"
                             :value="label.title + selectedTasks.globalUuid + label.id +key"
                             v-on:change="attemptChange(label.id, selectedTasks, label.title, selectedTasks.attepmtsCount)">
                      <div class="mdc-radio__background"
                           :style="{background: label.color}">
                        <div class="mdc-radio__outer-circle"></div>
                        <div class="mdc-radio__inner-circle"></div>
                        <label :for="'id' + selectedTasks.globalUuid + label.id + key">{{label.title}}</label>
                      </div>
                    </div>
                  </div>
                  <button type="button"
                          class="btn return-btn"
                          :disabled="!selectedTasks.attempt"
                          @click.prevent="backToPreviousAttempt(selectedTasks.globalUuid)">
                    <i class="material-icons mdc-button__icon">undo</i>
                  </button>
                </td>
                <td class="text-right text-cell">
                  <button type="button"
                          class="btn btn-link btn-link__table-text"
                          v-if="selectedTasks.toNextLevel && selectedTasks.selected && (selectedIndexTask !== tasks.length - 1)"
                          @click.prevent="goToNextLevel(selectedTasks.globalUuid, selectedTasks, selectedIndexTask)">
                    {{'protocol.next_criterion' | trans}}
                  </button>
                  <button type="button"
                          class="btn btn-link btn-link__table-text"
                          v-if="selectedTasks.toNextLevel && selectedTasks.selected && (selectedIndexTask === tasks.length - 1) && !selectedTasks.mastered && !selectedTasks.lastSessions.isMastered"
                          @click.prevent="goToNextLevel(selectedTasks.globalUuid, selectedTasks, selectedIndexTask)">
                    {{'protocol.master_criterion' | trans}}
                  </button>

                  <span class="nowrap"
                      v-if="selectedTasks.toNextLevel && selectedTasks.selected && (selectedIndexTask === tasks.length - 1) && (selectedTasks.mastered || selectedTasks.lastSessions.isMastered)">
                        {{'protocol.mastered_criterion' | trans}}
                      </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="selectedTasks && isMobile" >
            <div class="mobile-table position-relative">

              <div class="mobile-table__body">
                <div class="mobile-table__row">

                  <div class="container-load" v-if="selectedTasks.answer">
                    <svg viewbox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" :class="{'animate': selectedTasks.answer}">
                      <path d="M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z" stroke="#3da35a" fill="transparent"/>
                    </svg>
                  </div>

                  <div class="item">
                    <div class="cell">{{selectedTasks.description}}</div>
                    <div class="cell">
                      <button type="button"
                              class="btn btn-link btn-link__table-text"
                              v-if="selectedTasks.toNextLevel && selectedTasks.selected && (selectedIndexTask !== tasks.length - 1)"
                              @click.prevent="goToNextLevel(selectedTasks.globalUuid, selectedTasks, selectedIndexTask)">
                        {{'protocol.next_criterion' | trans}}
                      </button>
                      <button type="button"
                              class="btn btn-link btn-link__table-text"
                              v-if="selectedTasks.toNextLevel && selectedTasks.selected && (selectedIndexTask === tasks.length - 1) && !selectedTasks.mastered && !selectedTasks.lastSessions.isMastered"
                              @click.prevent="goToNextLevel(selectedTasks.globalUuid, selectedTasks, selectedIndexTask)">
                        {{'protocol.master_criterion' | trans}}
                      </button>

                      <span
                          v-if="selectedTasks.toNextLevel && selectedTasks.selected && (selectedIndexTask === tasks.length - 1) && (selectedTasks.mastered || selectedTasks.lastSessions.isMastered)">
                        {{'protocol.mastered_criterion' | trans}}
                      </span>
                    </div>
                    <div class="cell">{{selectedTasks.attempt}}</div>
                  </div>

                  <div class="mt-2 not-show"  v-if="selectedTasks.selected">
                      <span v-for="(answer, index) in selectedTasks.lastAnswers" class="item-box" :class="{'hidden': selectedTasks.lastAnswers.length > 5 && index < (selectedTasks.lastAnswers.length -5)}">
                        {{answer}}
                      </span><span v-for="n in emptyLength(selectedTasks.lastAnswers.length)" class="item-box-light"></span>
                  </div>

                  <div class="mt-2 stimul-row not-show"
                       :class="{'stimul-row-3' : (tasks.length/3) == 0}">

                    <div
                        class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                        v-for="(label, key) in selectedTasks.type.answers">
                      <div
                          class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                        <input :id="'id'+selectedIndexTask + selectedTasks.globalUuid + label.id +key"
                               type="radio" class="mdc-radio__native-control"
                               v-model="selectedTasks.answer"
                               :name="'radios'+selectedIndexTask + selectedTasks.globalUuid + label.id +key"
                               :key="label.title+selectedIndexTask + selectedTasks.globalUuid + label.id +key"
                               :value="label.title+selectedIndexTask + selectedTasks.globalUuid + label.id +key"
                               v-on:change="attemptChange(label.id, selectedTasks, label.title, selectedTasks.attepmtsCount)">
                        <div class="mdc-radio__background"
                             :style="{background: label.color}">
                          <div class="mdc-radio__outer-circle"></div>
                          <div class="mdc-radio__inner-circle"></div>
                          <label :for="'id'+selectedIndexTask + selectedTasks.globalUuid + label.id + key">{{label.title}}</label>
                        </div>
                      </div>
                    </div>
                    <button type="button"
                            class="btn return-btn not-show"
                            :disabled="!selectedTasks.attempt"
                            @click.prevent="backToPreviousAttempt(selectedTasks.globalUuid)">
                      <i class="material-icons mdc-button__icon">undo</i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="disabled-list mb-4"  @click.prevent="toggleViewDisabled()" :class="{'is-open': isOpenDisabled, 'is-list': nextTasks.length > 1}">

            <div v-for="task in nextTasks" :key="task.globalUuid"  class="list-item">
              <span>{{task.description}}</span>
            </div>

          </div>


          <div class="form-group row form-group-button stage-button"  v-if="!isClient">
            <div class="col-md-12">

              <button type="submit"
                      v-if="!isClient"
                      class="btn btn-primary btn-sm mr-2"
                      :disabled="disabledSave"
                      @click.prevent="saveStage(false)">
                {{'buttons.save' | trans}}
              </button>

              <button type="submit"
                      class="btn btn-link btn-sm mr-2 mt-2 mt-md-0"
                      v-if="isBCBA || isCurator"
                      @click.prevent="closeSession()">
                {{'protocol.buttons.finishEnvironment' | trans}}
              </button>

              <router-link class="btn btn-link btn-sm mr-2 mt-2 mt-md-0"
                           v-if="activeStageCount > 1"
                           :to="{ name: 'stage-list'}">
                <span>{{'buttons.back' | trans}}</span>
              </router-link>

            </div>
          </div>
        </div>


      </div>

      <div class="col-lg-4">
        <instruction :text="execution"
                     :header="'protocol.execution' | trans"
                     :short-text-length="180">
        </instruction>
      </div>

    </div>


  </form>

  <mdc-dialog v-model="isModalVisible"
              :title="title"
              :accept="'protocol.buttons.finishEnvironment' | trans"
              :cancel="'user.cancel' | trans"
              @accept="closeStage"
              @cancel="onModalClose">
  </mdc-dialog>

  <mdc-dialog v-model="isConflictModalVisible"
              :title="'protocol.confirm_save_conflict_session' | trans"
              :accept="'user.save' | trans"
              :cancel="'user.cancel' | trans"
              @accept="saveSession(false)"
              @cancel="onModalClose">
  </mdc-dialog>
  
    <mdc-dialog v-model="isChangeCurrent"
                :title="'protocol.change_criteria' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="changeCurrentTask"
                @cancel="onModalClose">
    </mdc-dialog>

  </div>

</template>

<script>
  import axios from 'axios';
  import {mapGetters, mapState, mapActions} from 'vuex';
  import filter from 'lodash/filter';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import Loader from '../../loader/components/Loader';
  import VueTimepicker from 'vue2-timepicker';
  import moment from 'moment';
  import Constants from '../../undesirableBehavior/Constants';
  import sortBy from 'lodash/sortBy';
  import map from 'lodash/map';
  import cloneDeep from 'lodash/cloneDeep';
  import forIn from 'lodash/forIn';
  import forEach from 'lodash/forEach';
  import fill from 'lodash/fill';
  import toInteger from 'lodash/toInteger';
  import concat from 'lodash/concat';
  import dropRight from 'lodash/dropRight';
  import drop from 'lodash/drop';
  import findIndex from 'lodash/findIndex'
  import Instruction from '@/common/instruction/components/InstructionView';
  import trim from 'lodash/trim';
  import lang from '../../../lang/translator';
  
  export default {
    components: {Instruction, Loader, VueTimepicker},
    name: 'ChainReactionStage',
    props: {
      'name': null,
      'clientData': null,
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stageId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        apiUrl: '/protocols/assigned/shaping/',
        apiClientUrl: '/users/clients/',
        apiCheckedUrl: '/protocols/assigned/',
        protocol: null,
        client: {},
        assignedProtocolId: null,
        loaded: false,
        isModalVisible:false,
        isConflictModalVisible: false,
        protocolsData: null,
        isLoaded: false,
        rangeDateStart: null, //new Date(),
        duration: null,
        rangeTimeStart: {
          HH: "",
          mm: ""
        },
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        showChangeDateSession: false,
        maxTotalAtemptsCountError: false,
        maxTotalAtemptsCount: 3000,
        hourRange: [0, 23],
        minuteRange: [0, 60],
        maxDateStart: this.getMaxDateStart(new Date()),
        tasks: [],
        timerId: null,
        totalAtemptsCount: 0,
        execution: '',
        disabledSave: true,
        currentSesssionDate: null,
        title: lang.get('protocol.confirm_close_env'),
        uuid: null,
        selectedIndex: null,
        isChangeCurrent: false,
        newCurrentId: null,
        changed: false,
        isOpenPrev: false,
        isOpenDisabled: false,
        majorVersion: null,
        endDate: null,
      };
    },
    computed: {
      ...mapState([
        'route',
      ]),
      ...mapGetters('auth', [
        'isClient',
        'isBCBA',
        'isCurator',
        'isPreviousDateSession',
        'previousDate',
        'previousTime',
        'previousDuration'
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapState('protocol', [
        'protocolVuexData',
      ]),
      minDate() {
        return this.protocolsData && this.protocolsData.endDate ? moment(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
      },
      showDatePrevious() {
        if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession  && this.previousTime && this.previousTime.HH && this.previousTime.mm){

          let protocolDate = moment(this.minDate).unix();


          let sessionDate = new Date(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm);
          let previous = moment(sessionDate).unix();

          return previous <= protocolDate;

        }

        return false;
      },
      prevTasks(){
        let prevTasks = filter(this.tasks, task => {
          return !task.selected && !task.disabled;
        });
        return prevTasks;
      },
      selectedTasks(){
        let selectedTasks = filter(this.tasks, task => {
          return task.selected;
        });
        return selectedTasks[0];
      },
      selectedIndexTask(){
        let selectedIndexTask = findIndex(this.tasks, task => {
          return task.selected;
        });
        return selectedIndexTask;
      },
      nextTasks(){
        let nextTasks = filter(this.tasks, task => {
          return task.disabled;
        });
        return nextTasks;
      },

      activeStageCount(){
        let activeList = filter(this.protocolsData.protocol.stages, stage => !stage.isClosed)

        return this.protocolsData && this.protocolsData.protocol.stages ?
            activeList.length :
            0;
      },

    },
    created() {
      this.protocolsData = cloneDeep(this.protocolVuexData);
      this.majorVersion = this.protocolsData.protocol.majorVersion;
      this.fetchProtocolData();
    },
    async mounted() {
      this.currentSesssionDate = Math.round((new Date()).getTime() / 1000);
      this.uuid = UuidGenerator.v4();
      let entity = {
        id: this.uuid,
        type: 'assigned-session',
      };
  
      this.setEntity(entity);

      
    },
    methods: {

      ...mapActions('appeals', [
        'setEntity',
      ]),

      ...mapActions('protocol', [
        'setProtocol',
      ]),

      toggleViewPrev(){
        this.isOpenPrev = !this.isOpenPrev;
      },

      toggleViewDisabled(){
        this.isOpenDisabled = !this.isOpenDisabled;
      },

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

      emptyLength(length){
        return 5-length > 0 ? 5-length : 0;
      },

      getMaxDateStart: function(date) {
        let clientTimeZoneOffset = moment().tz(this.clientData.timezone)._offset;
        let dateTime = moment(date, 'YYYY-MM-DD HH:mm').toDate();
        let dateWithTimezone = moment(dateTime.getTime() +
            (Math.abs(clientTimeZoneOffset) *
                Constants.SECONDS_PER_MINUTE * 1000)).toDate();

        return dateWithTimezone;
      },


      fetchProtocolData: async function() {
        try {

        let params = {};

        if(this.isPreviousDateSession && this.previousDate) {
          let newDate = moment(this.previousDate).format('YYYY-MM-DD');
          let newDateUnix = moment.utc(newDate, 'YYYY-MM-DD').unix();

          params = {
            date: newDateUnix
          };

        }
        let response = await axios.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId, {
          params: params,
        });
        if (response) {
          this.currentStage = response.data.data;
          
          this.assignedProtocolId = this.protocolsData.assigneeId;
          this.getClient(this.clientId || this.assignedProtocolId);
          this.initProtocolData();
        }
        } catch (e) {
          console.info(e)
          this.$router.push({name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId }});
        }
      },

      initProtocolData: function() {
        this.protocol = cloneDeep(this.protocolsData.protocol);
        this.execution = this.protocol.execution;
        let currentTaskPosition = 0;
        
        let targetIndex = filter(this.currentStage.stimuli, item => {
          return item.globalUuid === this.currentStage.targetStimulus.globalUuid
        })[0].position;

        this.tasks = map(this.currentStage.stimuli, (task, index) => {
          this.$set(task, 'lastSessions', []);
          if (task.globalUuid === this.currentStage.targetStimulus.globalUuid ){
            this.$set(task, 'selected', true);
            this.$set(task, 'lastSessions', this.currentStage.targetStimulus.lastSessions)
            this.$set(task, 'mastered', this.currentStage.targetStimulus.isMastered)
          }

          task.attempt = 0;
          task.attepmtsCount = '1';
          let lastAnswers = task.lastAnswers ? task.lastAnswers : [];
          this.$set(task, 'lastAnswers', lastAnswers);
          let lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
          this.$set(task, 'lastAnswersCount', lastAnswersCount);
          this.$set(task, 'answers', []);
          this.$set(task, 'type', this.currentStage.type);
          this.$set(task, 'toNextLevel', this.nextLevel(task));
          
          if(task.position > targetIndex){
            this.$set(task, 'disabled', true);
          }


          return task;

        });

        this.tasks = sortBy(this.tasks, 'position');

        let currentIndex = findIndex(this.tasks, item => {
          return item.globalUuid === this.currentStage.targetStimulus.globalUuid
        });


        this.isLoaded = true;

      },

      getClient: async function(clientId) {
        try {
          let response = await axios.get(this.apiClientUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        } finally {
          this.loaded = true
        }
      },
      backToPreviousPage() {
        if (this.clientId || this.assignedProtocolId) {
          this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
        }
        else {
          this.$router.push({name: 'protocols'});
        }
      },
      closeSession: function() {
        let stageActiveList = filter(this.protocol.stages, ['isClosed', false]);
        if (stageActiveList.length == 1){
          this.title = lang.get('protocol.confirm_close_all_env')
        }
        this.isModalVisible = true
      },
      onModalClose () {
        this.isModalVisible = false;
        this.isConflictModalVisible = false;
        this.isChangeCurrent = false;
      },

      changeCurrentTask(){
        this.isChangeCurrent = false;
        this.currentStage.targetStimulus.globalUuid = this.newCurrentId;
        this.isLoaded = false;
        this.saveStage(false, true)
      },

      today() {
        let dateTime = new Date();
        let dateWithTimezone = null;
        if (this.client.timezone) {
          dateWithTimezone = moment().
          tz(this.client.timezone).
          add(-(moment().utcOffset()), 'm')._d;
        } else{
          dateWithTimezone = dateTime.getTime() +
            (Math.abs(dateTime.getTimezoneOffset()) *
              Constants.SECONDS_PER_MINUTE * 1000);
        }

        return moment(dateWithTimezone).format('YYYY-MM-DD');
      },

      attemptChange: function(answer, task, title, answerCount) {

        if (this.timerId){
          clearTimeout(this.timerId);
        }

        let answerListCount = answerCount ? toInteger(answerCount) : 1;
        let answerList = fill(new Array(answerListCount), title);
        let answerListId = fill(new Array(answerListCount), answer);
        let lastDate = task.lastSessions.length ? task.lastSessions[task.lastSessions.length - 1].date : null;
        let lastDay = this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today();
        
        this.changed = true;

        this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
        if (this.totalAtemptsCount <= this.maxTotalAtemptsCount){
         
          this.maxTotalAtemptsCountError = false;

          forIn(this.tasks, (item, index) => {
            if (item.globalUuid == task.globalUuid) {
                item.answers = concat(item.answers, answerListId);
                item.attempt = item.attempt + answerListCount;
                item.lastAnswers = concat(item.lastAnswers, answerList);
                item.lastAnswersCount.push(answerCount);
                if (lastDate === lastDay) {
                  item.lastSessions[task.lastSessions.length - 1].attempts = concat(item.lastSessions[task.lastSessions.length - 1].attempts, answerListId);
                } else{
                  item.lastSessions.push({
                    date: lastDay,
                    attempts: answerListId,
                    mastered: false
                  })
                }
                item.mastered = false;

                this.$set(this.tasks[index], 'toNextLevel', this.nextLevel(item))
            }
          });

        } else{
          this.maxTotalAtemptsCountError = true;
          this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
          setTimeout(() => {
            this.$refs.maxTotalAtemptsCountError.scrollIntoView();
          }, 100);
        }

        this.disabledSave = false;

        this.timerId = setTimeout(function() {
          task.answer = null;
          task.attepmtsCount = '1';
        }, 300);

      },


      backToPreviousAttempt: function(id) {

        forIn(this.tasks, (item, key) => {
          if (item.globalUuid == id) {
            let lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

            item.answers = dropRight(item.answers, lastAnswersCount);

            item.lastAnswers = dropRight(item.lastAnswers, lastAnswersCount);
            item.attempt = item.attempt-lastAnswersCount;
            this.totalAtemptsCount  = this.totalAtemptsCount - lastAnswersCount;
            item.lastAnswersCount.pop();
            item.lastSessions[item.lastSessions.length - 1].attempts =  dropRight(item.lastSessions[item.lastSessions.length - 1].attempts, lastAnswersCount);
            
            if(!item.lastSessions[item.lastSessions.length - 1].attempts.length){
              item.lastSessions.pop();
            }
            
            item.toNextLevel = this.nextLevel(item);
 
            

            if(!this.totalAtemptsCount){
              this.disabledSave = true;
            }
          }

        });

      },

      selectAsCurrent: function(id) {

        this.isChangeCurrent = true;
        this.newCurrentId = id;

      },

      async checkSessionVersion() {

        let sessionVersion = axios.get(this.apiCheckedUrl + this.protocolsData.id + '/is-version-equal/' + this.majorVersion);

        return sessionVersion;

      },


      async saveStage(close, changeCurrent = false) {

        this.disabledSave = true;

        let checkVersion = await this.checkSessionVersion();
        let result = this.showChangeDateSession ? await this.$validator.validate('duration') : true;

        if (result && checkVersion.data.data.result) {
          this.saveSession(close, changeCurrent);
        } else{
          this.isConflictModalVisible = true;
        }

      },

      saveSession: async function(close, changeCurrent = false) {
        let that = this;
        let isSaved;
        this.isLoaded = false;
        this.errors.clear();

        let sessionDate = null;
        let sessionEndDate = null;
        let timeSessionDate = null;
        let timeSessionEndDate = null;

        if (this.isPreviousDateSession && this.previousTime.HH){
          let clientTimeZoneOffset = moment().tz(this.client.timezone)._offset;
          sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm));
          timeSessionDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
          timeSessionEndDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE) + this.previousDuration * Constants.SECONDS_PER_MINUTE;
        }

        let taskReactions = cloneDeep(this.tasks);

        taskReactions = map(taskReactions, (task) => {

          delete task['lastAnswers'];
          delete task['lastAnswersCount'];
          delete task['type'];
          delete task['attepmtsCount'];
          return task;

        });
        

        let startedAt = this.isPreviousDateSession ? timeSessionDate : (this.currentSesssionDate ? this.currentSesssionDate : Math.round((new Date()).getTime() / 1000));
        let finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round((new Date()).getTime() / 1000);

        let stageActiveList = filter(this.protocol.stages, ['isClosed', false]);

        isSaved = axios.post(this.apiUrl + this.protocolId + '/sessions',
            {

              'index': that.currentStage.position,
              'uuid': that.currentStage.uuid,
              'close': close,
              'majorVersion': this.majorVersion,
              'assignedSessions': [
                {
                  'uuid': this.uuid,
                  'startedAt': startedAt ,
                  'finishedAt': finishedAt,
                  'stimuli': taskReactions,
                  'type': that.currentStage.type,
                  'targetStimulus': {
                    "globalUuid": this.currentStage.targetStimulus.globalUuid,
                    "isMastered": this.currentStage.targetStimulus.globalUuid == this.tasks[this.tasks.length - 1].globalUuid && !!this.tasks[this.tasks.length - 1].mastered
                  }
                },
              ],

            }).then(response => {

                if(this.isClient) {
                  this.$router.push({name: 'available-protocols'});
                }


                this.setProtocol(null);

                if(close){

                  if (stageActiveList.length == 1){
                    this.$router.push({name: 'results', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId }});
                  } else{
                    this.$router.push({name: 'stage-list', params: { clientId: this.clientId, protocolData: null}});
                  }

                }
                
                if(changeCurrent){
                  this.uuid = UuidGenerator.v4();
                  let entity = {
                    id: this.uuid,
                    type: 'assigned-session',
                  };
  
                  this.setEntity(entity);
                  this.majorVersion = response.data.data.majorVersion;
  
                  if (this.isPreviousDateSession && this.previousTime.HH) {
                    let minute = this.previousDuration ? +this.previousDuration + +this.previousTime.mm : this.previousTime.mm;
                    let dateSession = new Date(this.previousDate.getFullYear(),
                        this.previousDate.getMonth(),
                        this.previousDate.getDate(),
                        this.previousTime.HH,
                        minute);
  
                    this.protocolsData.endDate = {
                      date: dateSession
                    };
                  }
                  this.fetchProtocolData();
                } else{

                  if (stageActiveList.length == 1){
                    this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
                  } else {
                    this.$router.push({name: 'stage-list', params: { clientId: this.clientId, protocolData: null}});
                  }
                }

                
                
                


            }).catch(error => {
              console.info(error)
              if (error.response) {
                this.disabled = false;
                this.isLoaded = true;
              }
            });

      },

      async closeStage() {

        this.saveSession(true);

      },

      goToNextLevel: function(uuid, task, index){

        let lastDay = this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today();

        if (index == this.tasks.length -1){

          this.$set(this.tasks[index], 'mastered', true);

        } else {
          task.selected = false;
          this.$set(this.tasks[index + 1], 'disabled', false);
          this.$set(this.tasks[index + 1], 'selected', true);
          this.$set(this.tasks[index + 1], 'lastSessions', [{
            date: lastDay,
            attempts: [],
            mastered: false
          }]);
          this.$set(this.tasks[index + 1], 'mastered', false);
          this.$set(this.currentStage.targetStimulus, 'globalUuid', this.tasks[index + 1].globalUuid);

        }
        this.disabledSave = false;
        this.changed = true;
      
      },

      nextLevel: function(item) {
        let positive = filter(this.currentStage.type.answers, function(item) { return item.himself; });
        let positiveAnswer = positive[0].id;
        let toNextLevel = false;

 
        let trialCount = this.currentStage.masteringCondition.trialCount;
        let sessionCount = this.currentStage.masteringCondition.sessionCount;
        

        if(item.lastSessions.length >= sessionCount){
          
          let sortedSession = sortBy(item.lastSessions, (date) => {
            return moment(date.date, 'YYYY-MM-DD').unix();
          });

          let lastSessions = drop(sortedSession, item.lastSessions.length - sessionCount);
          let mastered = false;
          let countMastered = 0;
          

          forIn(lastSessions, (answerList, index) => {

            let lastSessionAtempts = dropRight(answerList.attempts, answerList.attempts.length - trialCount);
            let lastSessionAtemptsCount = lastSessionAtempts.length;

            
            if (lastSessionAtemptsCount >= trialCount || answerList.isMastered) {
              
              if(answerList.isMastered){
                
                countMastered++;
                
              } else{
                
                let positiveAnswerCount = filter(lastSessionAtempts, function (item) {
                  return item == positiveAnswer;
                }).length;
                let trial = (positiveAnswerCount * 100 / lastSessionAtemptsCount) >= this.currentStage.masteringCondition.ratio;
                if (trial) {
                  countMastered++;
                } else {
                  mastered = false
                }
                
              }
       
              
            } else{
              return false;
            }
  
          });

            if(countMastered >= lastSessions.length){
              mastered = true;
            }

            toNextLevel =  mastered;

        } else {
          return false;
        }

        return toNextLevel;

      },


    },
    watch: {
      previousDate(newValue) {
        if (!this.changed && this.protocolsData.endDate && moment(this.previousDate).format('YYYY-MM-DD') == moment(this.protocolsData.endDate.date).format('YYYY-MM-DD')) {
          this.fetchProtocolData();
        }
      },
      previousTime(newValue) {
        /*if (this.protocolsData.endDate && moment(this.previousDate).format('YYYY-MM-DD') == moment(this.protocolsData.endDate.date).format('YYYY-MM-DD')) {
          this.fetchProtocolData();
        }*/
      },
      isPreviousDateSession(newValue) {
        if (!newValue) {
          if (!this.changed && this.protocolsData.endDate && moment(this.previousDate).format('YYYY-MM-DD') == moment(this.protocolsData.endDate.date).format('YYYY-MM-DD')) {
            this.fetchProtocolData();
          }
        }
      }
    }


    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ShapingCurrentStage.vue